import axios from 'axios'

export const axiosInstance = axios.create({
    baseURL: "https://subscription.api.app.getsmarteye.mobi/api/saas"
});

axiosInstance.defaults.headers.common["Accept"] = "application/json"
axiosInstance.defaults.headers.common["Content-Type"] = "application/json"